/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

export const Disclaimer = 'https://www.volcengine.com/docs/6348/68916';
export const ReversoContext = 'https://www.volcengine.com/docs/6348/68918';
export const UserAgreement = 'https://www.volcengine.com/docs/6348/128955';

const getDefaultProxyHost = () => {
  if (typeof window === 'undefined') {
    return 'https://cross.qietong.net';
  }
  return 'https://cross.qietong.net';
};

/**
 * @note 请求的 API Proxy Server(对应此 Demo 中包含的 Node server) 地址。
 *       您可按需改成自己需要访问的地址。
 */
export const AIGC_PROXY_HOST = process.env.REACT_APP_AIGC_PROXY_HOST || getDefaultProxyHost();

/**
 * @brief MQTT-over-WebSocket broker 端点
 * @note 浏览器直接通过 mqtt.js 连接 broker；mqtt.teeyouth.cn 的 WS path 是 /mqtt
 */
export const MQTT_BROKER_URL =
  process.env.REACT_APP_MQTT_BROKER_URL || 'wss://mqtt.teeyouth.cn/mqtt';
export const MQTT_USERNAME = process.env.REACT_APP_MQTT_USERNAME || '';
export const MQTT_PASSWORD = process.env.REACT_APP_MQTT_PASSWORD || '';
export const MQTT_CLIENT_ID_PREFIX = process.env.REACT_APP_MQTT_CLIENT_ID || 'php_ai_bot';

export const MQTT_TOPIC_CMD = (roomId: string) => `rtc-aigc/${roomId}/cmd`;
export const MQTT_TOPIC_STATE = (roomId: string) => `rtc-aigc/${roomId}/state`;

export interface IScene {
  icon: string;
  name: string;
  questions: string[];
  agentConfig: Record<string, any>;
  llmConfig: Record<string, any>;
  asrConfig: Record<string, any>;
  ttsConfig: Record<string, any>;
}
